import { App as CapacitorApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { isNativeMobileApp } from './platform';

const MOBILE_DEEP_LINK_SCHEMES = new Set(['correfood', 'br.com.correfood.app']);
let mobileDeepLinkListener = null;

function dispatchRouteChange() {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch {
    window.dispatchEvent(new Event('popstate'));
  }
}

function normalizeDeepLinkToAppPath(urlValue) {
  if (!urlValue) return null;

  try {
    const parsed = new URL(String(urlValue));
    const scheme = String(parsed.protocol || '').replace(':', '').toLowerCase();
    const host = String(parsed.hostname || '').toLowerCase();
    const pathname = parsed.pathname || '/';
    const suffix = `${pathname}${parsed.search || ''}${parsed.hash || ''}`;

    if (MOBILE_DEEP_LINK_SCHEMES.has(scheme)) {
      if (!host || host === 'app') return suffix || '/';
      return `/${host}${suffix}`.replace(/\/{2,}/g, '/');
    }

    // Suporte futuro para universal links.
    if (host === 'correfood.app' || host === 'app.correfood.com') {
      return suffix || '/';
    }
  } catch {
    return null;
  }

  return null;
}

export async function registerMobileDeepLinkListener() {
  if (!isNativeMobileApp() || mobileDeepLinkListener) return;

  mobileDeepLinkListener = await CapacitorApp.addListener('appUrlOpen', async ({ url }) => {
    const targetPath = normalizeDeepLinkToAppPath(url);
    if (!targetPath || typeof window === 'undefined') return;

    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (currentPath !== targetPath) {
      window.history.pushState({}, '', targetPath);
      dispatchRouteChange();
    }

    try {
      await Browser.close();
    } catch {
      // Ignore: browser pode nao estar aberto em todos os cenarios.
    }
  });
}

export async function unregisterMobileDeepLinkListener() {
  if (!mobileDeepLinkListener) return;
  await mobileDeepLinkListener.remove();
  mobileDeepLinkListener = null;
}
